import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
import OIcon from "../../../assets/O.svg";
import XIcon from "../../../assets/X.svg";
import DoubleArrow from "../../../assets/double_arrow_circle.svg";
const Wrapper = /*#__PURE__*/styled("section")({
  name: "Wrapper",
  class: "wazyzhi"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cdghhlx"
});
const SectionTitle = /*#__PURE__*/styled("div")({
  name: "SectionTitle",
  class: "s1o8wujb"
});
const SectionTextGroup = /*#__PURE__*/styled("ul")({
  name: "SectionTextGroup",
  class: "ssw7p6j"
});
const SectionItem = /*#__PURE__*/styled("li")({
  name: "SectionItem",
  class: "s14q9qn8"
});
const Section = /*#__PURE__*/styled("section")({
  name: "Section",
  class: "su97zo1"
});
const Divider = /*#__PURE__*/styled("div")({
  name: "Divider",
  class: "d14ml5al"
});
const ColoredBlock = /*#__PURE__*/styled("span")({
  name: "ColoredBlock",
  class: "cl0yq4u",
  vars: {
    "cl0yq4u-0": [props => props.isOrange ? theme.orange : theme.blue6]
  }
});
interface ISectionText {
  text: string;
  isO?: boolean;
}

const SectionText = ({
  text,
  isO
}: ISectionText) => {
  return <SectionItem>
      {isO ? <OIcon /> : <XIcon />}
      {text}
    </SectionItem>;
};

const ContactComparison = () => {
  return <Wrapper>
      <div>
        <Container>
          <Section>
            <SectionTitle>
              <div>
                <h3>
                  <ColoredBlock>従来型</ColoredBlock>の施設紹介
                </h3>
              </div>
              <div className="contents">
                <p>個人向けに限定したコンテンツ展開により</p>
                <p>施設の価値が伝えきれない</p>
              </div>
            </SectionTitle>
            <SectionTextGroup>
              {["個人向け旅行に限定したコンテンツ展開", "施設の価値が伝えきれていない", "法人の団体需要に適した情報の埋没"].map((text, idx) => {
              return <SectionText text={text} key={`section_text_${idx}`} />;
            })}
            </SectionTextGroup>
          </Section>
          <Section>
            <Divider />
            <DoubleArrow className="arrow" />
          </Section>
          <Section>
            <SectionTitle>
              <div>
                <h3>
                  <ColoredBlock isOrange>法人・団体特化型</ColoredBlock>
                  の施設紹介
                </h3>
              </div>
              <div className="contents">
                <p>法人・団体利用に特化した情報を提供し、利用イメージと</p>
                <p>魅力をダイレクトに伝えることができる</p>
              </div>
            </SectionTitle>
            <SectionTextGroup>
              {["法人・団体利用に特化したコンテンツ展開", "法人・団体への新たな施設価値の発見", "法人・団体需要に適した情報の最大化"].map((text, idx) => {
              return <SectionText text={text} key={`section_text_${idx}`} isO />;
            })}
            </SectionTextGroup>
          </Section>
        </Container>
      </div>
    </Wrapper>;
};

export { ContactComparison };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");